module.exports = __webpack_public_path__ + "static/media/om.ef546f54.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/om.png
// module id = 1950
// module chunks = 0